module.exports = __webpack_public_path__ + "static/media/play_store.60bb7a15.svg";